export const EXCMUSERDATAWORKPLACE_DELETE_RESET = 'EXCMUSERDATAWORKPLACE_DELETE_RESET'
export const EXCMUSERDATAWORKPLACE_DELETE_SET_ERROR = 'EXCMUSERDATAWORKPLACE_DELETE_SET_ERROR'
export const EXCMUSERDATAWORKPLACE_DELETE_SET_DELETED = 'EXCMUSERDATAWORKPLACE_DELETE_SET_DELETED'
export const EXCMUSERDATAWORKPLACE_DELETE_TOGGLE_LOADING = 'EXCMUSERDATAWORKPLACE_DELETE_TOGGLE_LOADING'
